import * as angular from 'angular';

const mainHtml = require('../views/main.html');

('use strict');
/* globals $ */
/**
 * @ngdoc overview
 * @name formDesignerApp
 * @description
 * # formDesignerApp
 *
 * Main module of the application.
 */

angular
  .module('formApp', [
    'datePicker',
    'dnTimepicker',
    'ngContextMenu',
    'ngResource',
    'ngCookies',
    'ngRoute',
    'dndLists',
    'debounce',
    'ngOnload',
    'frapontillo.bootstrap-switch',
    'ui.tinymce',
    'ui.bootstrap'
  ])
  .factory('constants', function () {
    // tslint:disable-next-line
    return {
      URL_REGEX:
        /^(?:.*{{.+}}.*|\/|(?:http(s)?:\/\/)(?:[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b|localhost)(?:[-a-zA-Z0-9@:%_\+.~#?&//=]*))$|^\/data$/,
      HTTPS_URL_REGEX:
        /^(?:.*{{.+}}.*|\/|(?:https:\/\/)(?:[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b|localhost)(?:[-a-zA-Z0-9@:%_\+.~#?&//=]*))$/,
      HTTP_HEADER_NAME_REGEX: /^(Authorization|{{[ -9;-~]:[ -9;-~]}}|X-(([ -9;-~]|{{[ -9;-~]+:[ -9;-~]+}})+))$/,
      HTTP_HEADER_BODY_REGEX: /^[ -~]+$/
    };
  })
  .filter('nl2br', [
    '$sce',
    function ($sce) {
      return function (text) {
        return text ? $sce.trustAsHtml(text.replace(/\n/g, '<br/>')) : '';
      };
    }
  ])
  .directive('stringToNumber', function () {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel: any) {
        ngModel.$parsers.push(function (value) {
          return '' + value;
        });
        ngModel.$formatters.push(function (value) {
          return parseFloat(value);
        });
      }
    };
  })
  .directive('formFileUploadChange', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        const onChangeHandler = scope.$eval(attrs.formFileUploadChange);
        element.on('change', onChangeHandler);
        element.on('$destroy', function () {
          element.off();
        });
      }
    };
  })
  .config(function ($routeProvider, CONFIG) {
    $routeProvider.when('/formId/:formId/nodeId/:nodeId', {
      templateUrl: mainHtml,
      controller: 'MainCtrl'
    });
    if (CONFIG.ENABLE_WEB_MODE) {
      $routeProvider.when('/web', {
        templateUrl: mainHtml,
        controller: 'MainCtrl'
      });
    }
    $routeProvider.otherwise({
      redirectTo: '/'
    });
  })
  .config([
    '$locationProvider',
    function ($locationProvider) {
      $locationProvider.hashPrefix('');
    }
  ])
  .run(function ($http, $cookies, CONFIG) {
    const getTitle = () => {
      const defaultTitle = 'Formulardesigner';

      switch (CONFIG.DERIVATIVE) {
        case 'amt24':
          return `${defaultTitle} - Amt24`;
        case 'bw':
          return `${defaultTitle} - Serviceportal Baden-Württemberg`;
        case 'ozghub':
          return `${defaultTitle} - Behörden-Serviceportal`;
        default:
          return defaultTitle;
      }
    };

    var token = 'Bearer ' + $cookies.get('SERVICEPORTAL_TOKEN');
    var regex = new RegExp('[\\?&]mandant=([^&#]*)');
    var matches = regex.exec(location.search);
    var mandant = matches === null ? '' : decodeURIComponent(matches[1].replace(/\+/g, ' '));
    token = token ? token.replace(/"/g, '') : '';
    $http.defaults.headers.common.Authorization = token;
    $http.defaults.headers.common['X-SP-Mandant'] = mandant;
    $.ajaxSetup({
      headers: {
        'X-SP-Mandant': mandant,
        Authorization: token
      }
    });

    const head = document.getElementsByTagName('head')[0];
    const favicon = document.createElement('link');
    favicon.href = `app/images/${CONFIG.DERIVATIVE}/favicon.${CONFIG.DERIVATIVE}.png`;
    favicon.rel = 'icon';
    head.appendChild(favicon);

    document.title = getTitle();
  });
